/**
 * @generated SignedSource<<0a4b58e3a9160db59d02135cd80743de>>
 * @relayHash 7d0bd576907e71ca3e05d3eedafb4e4a
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 7d0bd576907e71ca3e05d3eedafb4e4a

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propositionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "LinkMutationResponse",
    "kind": "LinkedField",
    "name": "generateMedicalCheckLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "link",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateMedicalCheckLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GenerateMedicalCheckLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7d0bd576907e71ca3e05d3eedafb4e4a",
    "metadata": {},
    "name": "GenerateMedicalCheckLinkMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "810480c89d0fb3ebd9c6f51642c2f0ac";

export default node;
